import { addColumnHeader } from "../helpers";

export const sumColumnPairs = (
  worksheet,
  outputSheet,
  rules,
  rule,
  fileSettings,
  inputColumns,
  outputColumns,
) => {
  Object.entries(rule.columnMappings).forEach(([key, value]) => {
    addColumnHeader(outputSheet, outputColumns, value);
  });

  const useOutputOf = rules.find(
    (rle) => parseInt(rle._id) === parseInt(rule.useOutputOf),
  );

  if (useOutputOf) {
    if (useOutputOf.ranges) {
      usingRanges(
        worksheet,
        outputSheet,
        rule.columnMappings,
        useOutputOf.output,
      );
    } else {
      usingIndecies(
        worksheet,
        outputSheet,
        rule.columnMappings,
        rule.columnsToSum,
        useOutputOf.output,
        rule.skipZeroValues,
        rule.skipEmptyCells,
      );
    }
  }
};

const usingRanges = () => {
  // Implement this function
};

const usingIndecies = (
  worksheet,
  outputSheet,
  columnMappings,
  columnsToSum,
  dateIndices,
  skipZeroValues,
  skipEmptyCells,
) => {
  let outputRow = 2;
  dateIndices.forEach((rowIndex) => {
    Object.entries(columnMappings).forEach(([key, outputColumn]) => {
      let cellValue = parseFloat(worksheet.getCell(`${key}${rowIndex}`).value);

      if (
        skipEmptyCells &&
        (cellValue === null || cellValue === undefined || cellValue === "")
      ) {
        return;
      }
      let pairs = findPairColumns(columnsToSum, key);

      if (pairs.length > 0) {
        let sumValue = cellValue;
        pairs.forEach((pairColumn) => {
          let pairCellValue = parseFloat(
            worksheet.getCell(`${pairColumn}${rowIndex}`).value,
          );
          sumValue += pairCellValue;
        });

        if (skipZeroValues && sumValue === 0) {
          return;
        }

        outputSheet.getCell(`${outputColumn}${outputRow}`).value = sumValue;
      } else {
        if (skipZeroValues && cellValue === 0) {
          return;
        }
        outputSheet.getCell(`${outputColumn}${outputRow}`).value = cellValue;
      }
      outputRow++;
    });
  });
};

const findPairColumns = (columnsToSum, key) => {
  let pairsFound = [];
  Object.values(columnsToSum).forEach((pair) => {
    if (pair.includes(key)) {
      pair.forEach((col) => {
        if (col !== key) {
          pairsFound.push(col);
        }
      });
    }
  });
  return pairsFound;
};
